import React, { useEffect, useState } from 'react'


const Countdown = (props) => {
    const [timeRemaining, setTimeRemaining] = useState(null);
    useEffect(() => {
        if(props.endDate){
          const interval = setInterval(() => {
            const now = new Date().getTime();
            const end = new Date(props.endDate).getTime();
            const difference = end - now;
            
        
            if (difference <= 0) {
              clearInterval(interval);
              setTimeRemaining({ days: 0, hours: 0, minutes: 0, seconds: 0 });
              return;
            }
        
            const days = Math.floor(difference / (1000 * 60 * 60 * 24));
            const hours = Math.floor(
              (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            const minutes = Math.floor(
              (difference % (1000 * 60 * 60)) / (1000 * 60)
            );
            const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        
            setTimeRemaining({ days, hours, minutes, seconds });
          }, 1000);
        
          return () => clearInterval(interval); }
        }, [props.endDate]);
    

    
  return (
    <>
    {timeRemaining ? <div className="d-flex">
    <div className="digit-box">
      <h6>{String(timeRemaining?.days).padStart(2, '0')}</h6>
      <p>Days</p>
    </div>
    <div className="digit-box">
      <h6>{String(timeRemaining?.hours).padStart(2, '0')}</h6>
      <p>Hours</p>
    </div>
    <div className="digit-box">
      <h6>{String(timeRemaining?.minutes).padStart(2, '0')}</h6>
      <p>Min</p>
    </div>
    <div className="digit-box">
      <h6>{String(timeRemaining?.seconds).padStart(2, '0')}</h6>
      <p>Sec</p>
    </div>
  </div>  : <></> }
  </>
  )
}

export default Countdown
